import { instantsInterceptor, } from '@/api/index';

function getContactList() {
    return instantsInterceptor.get('/contact/list');
}

function getContactMgmtList() {
    return instantsInterceptor.get('/mgmt/contact/member/list');
}

function getContactClsList() {
    return instantsInterceptor.get('/mgmt/contact/cls/list');
}

function saveContactCls(contactCls) {
    return instantsInterceptor.post('/mgmt/contact/cls/save', contactCls);
}

function getContact(cls) {
    return instantsInterceptor.post('/mgmt/contact/cls/view', cls);
}

function saveNewContactClsSort(contactCls) {
    return instantsInterceptor.post('/mgmt/contact/cls/sort/edit', contactCls);
}

function deleteContactCls(contactCls) {
    return instantsInterceptor.post('/mgmt/contact/cls/delete', contactCls);
}

function saveContactClsMember(memList) {
    return instantsInterceptor.post('/mgmt/contact/member/save', memList);
}


export {
    getContactList,
    getContactMgmtList,
    getContactClsList,
    saveContactCls,
    getContact,
    saveNewContactClsSort,
    deleteContactCls,
    saveContactClsMember
};